import MessageCopiesSentChart from "./MessageCopiesSentChart";

export default MessageCopiesSentChart